import { useEffect, useState } from 'react';

import { ThemeProvider } from '@mui/material/styles';
import { theme } from 'appStyles';

import RouterComponent from 'router/component';

import TestButtonBanner from 'widgets/testBannerButton/TestBannerButton.jsx';

import { AppContext, LoadersContext, SessionContext } from '_models/context/app';

import Grid from '@mui/material/Grid';
import Loader from 'widgets/loader/component';

function App() {
  /*** aplication values ***/
  const [appUser, setAppUser] = useState();
  const appValues = { appUser, setAppUser };

  /*** session values ***/
  const [sessionTicket, setSessionTicket] = useState();
  const [typeServiceSelect, setTypeServiceSelect] = useState('');

  const sessionValues = {
    sessionTicket,
    setSessionTicket,
    typeServiceSelect,
    setTypeServiceSelect,
  };

  const [isLoading, setIsLoading] = useState(false);
  const [isScreenLoading, setIsScreenLoading] = useState(false);

  const requiredEnvs = [
    'REACT_APP_ENV',
    'REACT_APP_API_URL',
    'REACT_APP_X_API_KEY',
    'REACT_APP_GOOGLE_MAPS_API_KEY',
    'REACT_APP_DEBUG',
  ];
  const missingEnvs = requiredEnvs.filter((env) => !process.env[env]);

  const loadersValue = {
    isLoading,
    setIsLoading,
    isScreenLoading,
    setIsScreenLoading,
  };

  const appEnv = process.env.REACT_APP_ENV;

  const [noSectionCls, setSectionCls] = useState('app-main-layout');

  useEffect(() => {
    if (appEnv !== 'PROD') {
      setSectionCls('app-main-layout no-prod-section');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <LoadersContext.Provider value={loadersValue}>
        <AppContext.Provider value={appValues}>
          <SessionContext.Provider value={sessionValues}>
            <div>
              {/* Mensaje de error de configuración si falta un ENV */}
              {missingEnvs.length > 0 && (
                <div
                  style={{
                    background: 'red',
                    color: 'white',
                    padding: '10px',
                    textAlign: 'center',
                    fontWeight: 'bold',
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    zIndex: 999999,
                  }}
                >
                  Error en la configuración: faltan variables de entorno ({missingEnvs.join(', ')}).
                </div>
              )}
              {appEnv !== 'PROD' ? <TestButtonBanner appEnv={appEnv} /> : null}
              <Grid>
                <header className='app-main-header'></header>

                <section className={noSectionCls}>
                  <RouterComponent />
                </section>
                <footer className='app-main-footer'></footer>
              </Grid>
            </div>
          </SessionContext.Provider>
        </AppContext.Provider>
        <Loader loading={isScreenLoading} mainScreenLoader={true} />
      </LoadersContext.Provider>
    </ThemeProvider>
  );
}

export default App;
